import { LoadShortDate } from "./LoadShortDate";
import { LoadShortTime } from "./LoadShortTime";

const TelemetryToCSV = (telemetryHistory, fileName, formatTime = true) => {
  if (!telemetryHistory || telemetryHistory.length === 0) return;

  const keys = Object.keys(telemetryHistory[0]).filter(k => k !== "ts");

  // Conditionally set headers
  const header = formatTime
    ? `Date,Time,${keys.join(",")}`
    : `Timestamp,${keys.join(",")}`;

  // Build CSV rows
  const csvContent = [
    header,
    ...telemetryHistory.map(item => {
      const rowPrefix = formatTime
        ? `${LoadShortDate(item.ts)},${LoadShortTime(new Date(item.ts).toISOString())}`
        : `${item.ts}`;
      const values = keys.map(k => item[k] ?? "").join(",");
      return `${rowPrefix},${values}`;
    })
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", fileName ?? "telemetry_data.csv");

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
export default TelemetryToCSV;